/**
 * MyGemaPro APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TemplateDetailDto } from './templateDetailDto';
import { BuildingItemDto } from './buildingItemDto';
import { BuildingSectionImagesDto } from './buildingSectionImagesDto';
import { InspectionPermissions } from './inspectionPermissions';
import { AttachmentDetailDto } from './attachmentDetailDto';
import { TenantItemDto } from './tenantItemDto';
import { UserItemDto } from './userItemDto';
import { InspectionArchiveImagesDto } from './inspectionArchiveImagesDto';


export interface InspectionDetailDto { 
    id: string;
    creatorTenant: TenantItemDto;
    ownerTenant: TenantItemDto;
    name: string;
    description: string;
    note?: string;
    building: BuildingItemDto;
    technician: UserItemDto;
    clerk?: UserItemDto;
    fromTimestamp: string;
    toTimestamp: string;
    sendingTimestamp?: string;
    continuationNumber: number;
    version: number;
    normType: InspectionDetailDto.NormTypeEnum;
    inspectionType: InspectionDetailDto.InspectionTypeEnum;
    status: InspectionDetailDto.StatusEnum;
    archiveImages: Array<InspectionArchiveImagesDto>;
    coverImage?: AttachmentDetailDto;
    locationReplacement?: AttachmentDetailDto;
    lastSavedTimeStamp: string;
    usedTemplate?: TemplateDetailDto;
    buildingSectionImagesDto?: Array<BuildingSectionImagesDto>;
    allowIncompleteUpload: boolean;
    usesRiskAssessment: boolean;
    permissions: InspectionPermissions;
    deleted: boolean;
}
export namespace InspectionDetailDto {
    export type NormTypeEnum = 'NORM_1300' | 'NORM_1301';
    export const NormTypeEnum = {
        Norm1300: 'NORM_1300' as NormTypeEnum,
        Norm1301: 'NORM_1301' as NormTypeEnum
    };
    export type InspectionTypeEnum = 'REGULAR' | 'SCHADSTELLENPLAN';
    export const InspectionTypeEnum = {
        Regular: 'REGULAR' as InspectionTypeEnum,
        Schadstellenplan: 'SCHADSTELLENPLAN' as InspectionTypeEnum
    };
    export type StatusEnum = 'DRAFT' | 'TODO' | 'IN_PROGRESS' | 'IN_REVIEW' | 'DONE' | 'SENT' | 'NONE';
    export const StatusEnum = {
        Draft: 'DRAFT' as StatusEnum,
        Todo: 'TODO' as StatusEnum,
        InProgress: 'IN_PROGRESS' as StatusEnum,
        InReview: 'IN_REVIEW' as StatusEnum,
        Done: 'DONE' as StatusEnum,
        Sent: 'SENT' as StatusEnum,
        None: 'NONE' as StatusEnum
    };
}


